import { fetchApi } from '@/config/axiosSetting';
import {
  GetVehicleInformationType,
  getVehicleInformationType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleInformation/getVehicleInformation.type';

export const getVehicleInformationFunction = ({
  id,
  damaged_id,
}: getVehicleInformationType): Promise<GetVehicleInformationType> => {
  return fetchApi.get(
    `/property/reports/${id}/accident_users/damaged/vehicle_information/`,
    {
      params: {
        damaged_id,
      },
    },
  );
};
